class NavHover {
  constructor(element) {
    this.element = element;
    this.init();
  }

  getElement() {
    return this.element;
  }

  getNavItem() {
    let element = this.getElement();
    return element.querySelectorAll('.js-navItem');
  }

  getNav() {
    let element = this.getElement();
    return element.querySelectorAll('.js-hover');
  }

  setBg() {
    let parentNav = this.getNav();

    for(let nav of parentNav) {
      nav.addEventListener('mouseenter', () => {
        if(!nav.closest('.Header').classList.contains('show-bg')){
          nav.closest('.Header').classList.add('show-bg');
        }
      })
    }
  }

  setNavItem() {
    let navItemEl = this.getNavItem();

    for(let navItem of navItemEl) {
      navItem.addEventListener('mouseenter', () => {
        let imageContainer = navItem.closest('.js-hover').querySelector('.js-image');
        let navImage = navItem.dataset.collectionImage;

        imageContainer.src = navImage;
      })
      navItem.addEventListener("mouseleave", () => {
        let imageContainer = navItem.closest('.js-hover').querySelector('.js-image');
        imageContainer.src = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';
      });
    }
  }

  setEventHandlers() {
    this.setNavItem();
    this.setBg();
  }

  init() {
    this.setEventHandlers();
  }
}


const NavHoverInit = {
  init() {
    const $el = document.querySelector("header");
    if ($el) {
        new NavHover($el);
    }
  },
};


export default NavHoverInit;